module.exports = __webpack_public_path__ + "static/Efreet-278c1d66ca81df8b8e5cab67c7e4e932.jpg";